export default __webpack_public_path__ + "static/media/avatar_59.ec6f260f.png";